useRegisterSSRObservable